export enum SdaTargetTypes {
  none = 'none',
  extension = 'extension',
  service = 'service',
}
